import { Table, Space, Button, Row, Col, Input, Select, Typography, Tooltip, Pagination } from "antd";
import { SearchOutlined, FilePdfOutlined } from "@ant-design/icons";
import { CiSquarePlus } from "react-icons/ci";
import { Divider } from "antd";
import React, { useEffect, useState } from "react";
import AddModal from "./AddDebitNote";
import { debitNoteService, dropdownService } from "../../../../../services";
import { Link } from "react-router-dom";
import { changeDocumentTitle } from "../../../../../utils/title";
import { useDebounce } from "../../../../../hooks/useDebounce";

const { Title } = Typography
function DebitNotes() {
  const [loading, setLoading] = useState(false);
  const [debitNotes, setDebitNotes] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    total: 0,
    pageSize: 10,
  });
  const [companies, setCompanies] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [expenses, setExpenses] = useState([]);
  const [refresh, setRefresh] = useState(true);
  const [isModalShow, setIsModalShow] = useState(false);
  const [search, setSearch] = useState(null);
  const debouncedSearch = useDebounce(search, 500);

  const showModal = () => setIsModalShow(true);

  const handleCancel = () => {
    setIsModalShow(false);
  };

  const options = [
    {
      value: "10",
      label: "10",
    },
    {
      value: "25",
      label: "25",
    },
    {
      value: "50",
      label: "50",
    },
  ];
  const columns = [
    {
      title: "Id",
      dataIndex: "id",
      key: "id",
      render: (text, record, index) =>
        (pagination.current - 1) * pagination.pageSize + index + 1,
    },
    {
      title: "Company",
      dataIndex: ["company", "name"],
      key: "company",
    },
    {
      title: "Customer",
      dataIndex: ["user", "name"],
      key: "user",
    },
    {
      title: "Invoice #",
      dataIndex: "invoice_id",
      key: "invoice_id",
      render: (text, record) => text || "N/A",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "Expense",
      dataIndex: ["expense", "id"],
      key: "Expense",
    },
    {
      title: "Issue Date",
      dataIndex: "issue_date",
      key: "issue_date",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      width: 300,
    },
    {
      title: "Action",
      key: "Action",
      fixed: "right",
      render: (text, record, { _id }) => (
        <Link to={`/accounts/debit-notes/PDF/${record.id}`}>
          <Tooltip title='Pdf'>
            <FilePdfOutlined />
          </Tooltip>
        </Link>
      ),
    },
  ];

  const initialize = async (page = 1, pageSize = pagination.current) => {
    setLoading(true);
    const { success, data } = await debitNoteService.fetch(page, pageSize, debouncedSearch);
    if (success) {
      setDebitNotes(data.data);
      setPagination((prev) => ({
        ...prev,
        total: data.total,
        current: page,
        pageSize,
      }));
    }
    setLoading(false);
  };

  const getCompanies = async () => {
    const response = await dropdownService.fetchCompanies();
    if (response.success) {
      setCompanies(response.data);
    }
  };
  const getCustomer = async () => {
    const response = await dropdownService.fetchCustomers();
    if (response.success) {
      setCustomers(response.data);
    }
  };
  const getInvoices = async () => {
    const response = await dropdownService.fetchInvoices();
    if (response.success) {
      setInvoices(response.data);
    }
  };
  const getExpenses = async () => {
    const response = await dropdownService.fetchExpenses();
    if (response.success) {
      setExpenses(response.data);
    }
  };

  useEffect(() => {
    changeDocumentTitle("Debit Notes");
    getCompanies();
    getCustomer();
    getInvoices();
    getExpenses();
  }, [])

  useEffect(() => {
    initialize(pagination.current, pagination.pageSize);
  }, [debouncedSearch]);


  return (
    <div
      style={{
        padding: "5px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#FFFFFF",
      }}
    >

      <div className="flex justify-between items-center">
        <h1 style={{ fontWeight: "bold" }} className="pl-2 pt-3">
          Debit Notes
        </h1>
        <Input
          placeholder="Search by Company , Customer & Invoice No"
          prefix={<SearchOutlined />}
          style={{
            width: "37%",
            borderRadius: "20px",
            fontSize: 14,
            margin: 10
          }}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div className="flex justify-end">
        <Button
          type="primary"
          onClick={showModal}>
          Add Debit Note
        </Button>
      </div>

      <AddModal
        visible={isModalShow}
        setIsModalShow={setIsModalShow}
        onCancel={handleCancel}
        companies={companies}
        customers={customers}
        invoices={invoices}
        expenses={expenses}
        setRefresh={setRefresh}
      />

      <Table
        columns={columns}
        scroll={{ x: "max-content" }}
        dataSource={debitNotes}
        rowKey="id"
        loading={loading}
        style={{ marginTop: "10px" }}
        pagination={false}
        footer={() => (
          <div className="flex justify-between items-center text-xs ">
            <div className=" text-gray-600">
              Showing {(pagination.current - 1) * pagination.pageSize + 1} to{" "}
              {Math.min(pagination.current * pagination.pageSize, pagination.total)} of{" "}
              {pagination.total} entries
            </div>
            <Pagination
              current={pagination.current}
              total={pagination.total}
              pageSize={pagination.pageSize}
              showSizeChanger={false}
              onChange={(page) => initialize(page, pagination.pageSize, search)}
              itemRender={(current, type, originalElement) => {
                if (type === "prev") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Previous</a>;
                if (type === "next") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Next</a>;
                return originalElement;
              }}
            />
          </div>
        )}
      />
    </div>
  );
}

export default DebitNotes;
